<template>
  <div class="text-textColor">
    <transition name="fade">
      <div
        v-if="showCreateSmsTemplate"
        class="bg-black fixed bg-opacity-70 inset-0 z-50 h-screen w-full"
      >
        <form
          @submit.prevent="createSmsTemplate"
          class="fixed center-h-v bg-white rounded-md shadow-2xl sm:w-2/5 w-full"
        >
          <transition name="fade">
            <div
              v-if="loading"
              class="inset-0 absolute bg-black rounded-md bg-opacity-40 w-full"
            >
              <loader class="center-h-v" />
            </div>
          </transition>

          <div class="flex justify-between items-center border-b-1.5 p-3">
            <p class="text-base">Create SMS Template</p>
            <img
              class="h-6 object-contain cursor-pointer hover:shadow-lg bg-primary rounded-md"
              src="@/assets/icons/cross-white.png"
              @click="close()"
            />
          </div>

          <transition name="fade">
            <div
              v-if="create_error"
              class="p-1 text-center text-sm w-full bg-yellow-200"
            >
              {{ create_error }}
            </div>
          </transition>

          <div class="flex flex-col p-4 gap-5">
            <div class="text-sm">
              <label class="block pb-1">Template Name</label>
              <input
                v-model="data.TemplateName"
                type="text"
                class="p-2 bg-gray-200 rounded-full w-full"
              />
            </div>
            <div class="text-sm">
              <label class="block pb-1">Template Body</label>
              <textarea
                rows="12"
                v-model="data.TemplateBody"
                type="text"
                class="p-2 bg-gray-200 rounded-md w-full"
              ></textarea>
            </div>
          </div>
          <div class="flex justify-end p-5">
            <button
              type="submit"
              class="bg-primary rounded-full px-10 text-sm text-white py-2"
            >
              Save
            </button>
          </div>
        </form>
      </div>
    </transition>
  </div>
</template>

<script>
import Loader from "@/components/loader/loader.vue";
import axios from "axios";
import { mapGetters } from "vuex";
export default {
  name: "CreateSmsTemplate",
  props: ["showCreateSmsTemplate"],
  components: { Loader },
  data() {
    return {
      loading: false,
      create_error: null,
      data: {
        TemplateName: null,
        TemplateBody: null,
      },
    };
  },
  computed: {
    ...mapGetters(["getToken"]),
  },
  methods: {
    close() {
      this.$emit("close");
    },
    createSmsTemplate() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": "application/json",
        },
      };
      axios
        .post(
          `setup/sms/template/${this.$ApiVersion}/create`,
          JSON.stringify(this.data),
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.$emit("closeOnSuccess", response.data.StatusMessage);
            } else {
              this.create_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.create_error = error.message;
          }
        );
    },
  },
};
</script>

<style scoped>
.center-h-v {
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
</style>
